import * as ReactDatetime from "@sgwt-widget-hack/react-datetime";
import { WithGlobalCss } from "@sgwt-widget/core";
import { format } from "date-fns";
import { Component, h } from "preact";
import * as css from "./spl-react-date-time.less";

interface IState {
  fromDate: any;
  toDate: any;
  fromId: string;
  toId: string;
}
interface IProps {
  type?: string;
  value?: string;
  id?: string;
  userSelection?: object;
  label?: string;
  onChangeFromDate(event: any): void;
  onChangeToDate(event: any): void;
}
export const DealListDateRange = class extends Component<IProps, IState> {
  private readonly currentDate = new Date();
  public constructor() {
    super();
    this.setState({
      fromDate: this.currentDate.toISOString().slice(0, 4) + "-01-01",
      toDate: this.currentDate.toISOString().slice(0, 10),
    });
    this.changeFromDate = this.changeFromDate.bind(this);
    this.changeToDate = this.changeToDate.bind(this);
  }
  public render(): JSX.Element {
    return (
      <WithGlobalCss styles={css}>
        <div class={`${css.locals.splReactDateTime}`}>
          <div class="col-md-4 ">
            <div class="form-group">
              <div class="input-group">
                <span class="input-group-btn">
                  <button
                    class={`btn btn-primary`}
                    disabled
                    style="opacity:unset; cursor: unset"
                  >
                    From
                  </button>
                </span>
                <ReactDatetime
                  defaultValue={this.state.fromDate}
                  closeOnSelect={true}
                  dateFormat="YYYY-MM-DD"
                  timeFormat={false}
                  onChange={this.changeFromDate}
                />
              </div>
            </div>
          </div>
          <div class=" col-md-4">
            <div class="form-group">
              <div class="input-group">
                <span class="input-group-btn">
                  <button
                    class={`btn btn-primary`}
                    disabled
                    style="opacity:unset; cursor: unset"
                  >
                    To
                  </button>
                </span>
                <ReactDatetime
                  defaultValue={this.state.toDate}
                  closeOnSelect={true}
                  dateFormat="YYYY-MM-DD"
                  timeFormat={false}
                  onChange={this.changeToDate}
                />
              </div>
            </div>
          </div>
        </div>
      </WithGlobalCss>
    );
  }

  private changeToDate(v: any): void {
    const fromDate = new Date(this.state.fromDate);
    const toDateString = format(v, "YYYY-MM-DD");
    const toDate = new Date(toDateString);
    if (fromDate > toDate) {
      this.setState({
        fromDate:
          toDate.toISOString().slice(0, 4) +
          fromDate.toISOString().slice(4, 10),
        toDate: toDateString,
      });
    } else {
      this.setState({ toDate: toDateString });
    }
    this.props.onChangeToDate(toDateString);
  }

  private changeFromDate(v: any): void {
    this.setState({ fromDate: format(v, "YYYY-MM-DD") });
    this.props.onChangeFromDate(this.state.fromDate);
  }
};
